import { render, staticRenderFns } from "./onUploadSuccess-editor.vue?vue&type=template&id=40a94791&scoped=true&"
import script from "./onUploadSuccess-editor.vue?vue&type=script&lang=js&"
export * from "./onUploadSuccess-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a94791",
  null
  
)

export default component.exports